<template>
    <div class="header-info-wrapper">
        <!--<Navbar :currentView="currentView" @change-view="$emit('change-view', $event)"
           @show-new-question-modal="$emit('show-new-question-modal', $event)" />-->

        <BreadcrumbElement v-if="$root.user?.active" :items="breadcrumbItems" :currentPage="currentPage"
            @change-view="$emit('change-view', $event.view, $event.elementId)" />

          <!--<div v-if="!$root.user" class="shadow d-none d-lg-block" style="background-color: #00468b;">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-12">
						<div class="it-header-center-content-wrapper mt-3">
							<BreadcrumbNode :article="this.$root.breadcrumbData.article" :section="this.$root.breadcrumbData.section"/>
						</div>
					</div>
				</div>
			</div>
		</div>  -->

        <div v-if="$root.user?.active" class="user-info d-flex justify-content-between align-items-center mt-2 mb-3">
            <div class="user-level">
                Livello utente Autorizzato
            </div>
            <div class="welcome">
                Benvenuto <span class="fw-bold">{{ $root.user?.nome + ' ' + $root.user?.cognome || 'Utente' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from './Navbar.vue';
import BreadcrumbElement from '../common/BreadcrumbElement.vue';
import { breadcrumbMap } from '../../components/breadcrumbMap.js';
import ModalView from '../common/ModalView.vue';
import BreadcrumbNode from '../../components/navigator/BreadcrumbNode.vue';

export default {
    name: 'HeaderInfo',
    components: { Navbar, BreadcrumbElement, ModalView, BreadcrumbNode },
    props: {
        currentView: Object,
        breadcrumbItems: {
            type: Array,
            default: () => []
        },
        currentPage: String,
        username: String
    },
    data() {
        return {
            showNewQuestionModal: false,
            modalTargetView: null
        }
    },
    computed: {
        breadcrumbItems() {
            return breadcrumbMap[
                typeof this.currentView === 'string'
                    ? this.currentView
                    : this.currentView?.name
            ] || breadcrumbMap['QuestionsView'];
        },
        currentPage() {
            const items = this.breadcrumbItems;
            return items.length ? items[items.length - 1].title : '';
        }
    },
    methods: {
        handleNewQuestionChoice(version) {
            this.showNewQuestionModal = false;
            if (version === '50/2016') {
                // naviga ad altra vista
                this.$emit('change-view', 'SomeOtherView');
            } else {
                // rimani sulla stessa pagina (ArticlesView)
            }
        },
        handleShowNewQuestion(view) {
            console.log('Evento intercettato!', view)
            this.showNewQuestionModal = true
            this.modalTargetView = view  // memorizza la vista di destinazione
        }
    },
    emits: ['change-view']
};
</script>

<style scoped>
.header-info-wrapper {
    margin-top: 21rem;
    padding: 0 1rem;
}

.user-info {
    font-size: 1rem;
}
</style>
